import Layout from '@4c/layout';
import PropTypes from 'prop-types';
import React from 'react';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Toast from './Toast';
import ToastContext from './ToastContext';
import ToastTransition from './ToastTransition';
const styles = require('./ToastContainer-styles.module.scss');
const propTypes = {
  dismissAfter: PropTypes.number.isRequired
};

function ToastContainer({
  dismissAfter
}) {
  return React.createElement(ToastContext.Consumer, null, ({
    toasts
  }) => React.createElement(TransitionGroup, {
    component: Layout,
    direction: "column",
    className: styles.container
  }, toasts.map(toast => React.createElement(ToastTransition, {
    key: toast.key
  }, React.createElement(Toast, {
    toast: toast,
    dismissAfter: dismissAfter
  })))));
}

ToastContainer.propTypes = propTypes;
export default ToastContainer;